import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import { StripeController } from "./solidus_stripe_payment_controller"

const application = Application.start()
const context = require.context(".", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
application.register("solidus-stripe-payment", StripeController)

console.log("Stimulus controllers index loaded and Stripe manually registered"); 